import React from "react";
import { Policy } from "../../../../../../../../store/Policies/Types";
import { PremiumView } from "../../../../../00-blocks/Policies/component/PremiumView";

interface Props {
    policy: Policy;
    sidebarCollapsed: boolean;
}

export const Premium: React.FC<Props> = (props: Props) => (
    <PremiumView formData={{ content: props.policy }} asAudit sidebarCollapsed={props.sidebarCollapsed} />
);
